module.exports = __webpack_public_path__ + "img/loader.fcd8d05c.gif";